export const FMD_SET_SIDEBAR = 'FMD_SET_SIDEBAR';
export const FMD_SET_VIEW = 'FMD_SET_VIEW';
export const FMD_SET_FILTERS = 'FMD_SET_FILTERS';
export const FMD_SET_FILTERS_DATA = 'FMD_SET_FILTERS_DATA';
export const FMD_SET_FILTERS_LOADING = 'FMD_SET_FILTERS_LOADING';
export const FMD_SET_DATA = 'FMD_SET_DATA';
export const FMD_SET_LOADING = 'FMD_SET_LOADING';
export const FMD_SET_MODAL_LIST = 'FMD_SET_MODAL_LIST';
export const FMD_SET_MODAL_LIST_LOCATIONS = 'FMD_SET_MODAL_LIST_LOCATIONS';
